module.exports = __webpack_public_path__ + "img/icon-sb-call-us-blue-color-48.2519a8a.svg";